import { useState, useEffect } from "react";

const ScrollProgress = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const currentScroll = window.pageYOffset;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      
      if (scrollHeight > 0) {
        setScrollProgress((currentScroll / scrollHeight) * 100);
      }
    };

    window.addEventListener("scroll", updateScrollProgress);
    return () => window.removeEventListener("scroll", updateScrollProgress);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] h-1 bg-background/20">
      <div
        className="h-full bg-gradient-to-r from-gold via-gold-light to-gold-accent transition-all duration-150 shadow-gold-glow"
        style={{ 
          width: `${scrollProgress}%`,
          boxShadow: 'var(--shadow-gold-glow)'
        }}
      />
    </div>
  );
};

export default ScrollProgress;
